"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
const Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const globalVariables_1 = require("../../../common/globalVariables");
const NotificationList_1 = __importDefault(require("../Notifications/NotificationList"));
const NotificationDetail_1 = __importDefault(require("./NotificationDetail"));
const NotificationPermissions_1 = __importDefault(require("../Notifications/NotificationPermissions"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const NotificationsPage = styled_components_1.default.div `
  max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;
  height: 100%;
  background: #fff;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  gap: 16px;

  .simple-list {
    .simple-item {
      border: solid 2px blue;
    }
  }
`;
const NoNotificationsWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 10vmin auto;

  .notifications-icon {
    font-size: 75px;
    padding: 15px;
    border-radius: 50%;
    background-color: #e1e6e8;
    margin-bottom: 25px;
    overflow: visible;
  }

  p {
    font-weight: 400;
    letter-spacing: 0.5px;
    color: #737373;
  }
`;
const PermisisonWrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 16px;
  width: 100%;
  padding: 0 16px;
  left: 0px;
  display: flex;
  justify-content: center;

  .permission-controls {
    width: 100%;
  }

  @media screen and (min-width: 1000px) {
    .permission-controls {
      width: 700px;
    }
  }
`;
const Notifications = ({ userData, currentLocale, match, history, baseUrl, }) => {
    const [windowWidth, setWindowWidth] = (0, react_1.useState)(window.innerWidth);
    const [groups, setGroups] = (0, react_1.useState)([]);
    const [selectedNotification, setSelectedNotification] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [toast, setToast] = (0, react_1.useState)("");
    const hideToast = () => {
        setToast("");
    };
    const updateWindowWidth = () => {
        setWindowWidth(window.innerWidth);
    };
    const markAllAsRead = () => {
        services_1.apiService.markAllAsRead(currentLocale, userData.token).then((data) => {
            setGroups(data.groups);
            const event = new CustomEvent("fetchNotificationBadge");
            window.dispatchEvent(event);
            const channel = new BroadcastChannel("notifications");
            channel.postMessage({});
            setToast(i18n_js_1.default.t("notification_center_marked_as_read_toast_text"));
        });
    };
    const getMarkedNotificationsByReferenceId = (notificationReferenceId, notificationList) => {
        // mark notification as read
        const tempGroup = [...notificationList];
        tempGroup.forEach((groupItem, indexOfGroup) => groupItem.notifications.forEach((notificationItem, indexofNotification) => {
            if (notificationItem.reference.id === notificationReferenceId) {
                const notificationsSublist = tempGroup[indexOfGroup].notifications;
                tempGroup[indexOfGroup].notifications = [
                    ...notificationsSublist.slice(0, indexofNotification),
                    Object.assign({}, groupItem.notifications[indexofNotification], {
                        read: true,
                    }),
                    ...notificationsSublist.slice(indexofNotification + 1),
                ];
            }
        }));
        return [...tempGroup];
    };
    const fetchNotificationList = (firstRender) => {
        const { id } = match.params;
        services_1.apiService
            .getNotificationList(currentLocale, userData.token)
            .then((data) => {
            setIsLoading(false);
            if (id && firstRender) {
                let foundNotification = null;
                data.groups.forEach((group) => {
                    if (foundNotification) {
                        return;
                    }
                    foundNotification = group.notifications.find((notification) => notification.reference.id === id);
                });
                if (foundNotification) {
                    setSelectedNotification(foundNotification);
                }
                const markedNotifications = getMarkedNotificationsByReferenceId(id, data.groups);
                setGroups(markedNotifications);
            }
            else {
                setGroups(data.groups);
            }
        });
    };
    (0, react_1.useEffect)(() => {
        const fetchFunc = () => {
            fetchNotificationList(false);
        };
        fetchNotificationList(true);
        window.addEventListener("resize", updateWindowWidth);
        window.addEventListener("markAllAsRead", markAllAsRead);
        window.addEventListener("refetchNotifications", fetchFunc);
        return () => {
            window.removeEventListener("resize", updateWindowWidth);
            window.removeEventListener("markAllAsRead", markAllAsRead);
            window.removeEventListener("refetchNotifications", fetchFunc);
        };
    }, []);
    const checkDetails = (newSelectedNotification) => {
        const ref = newSelectedNotification.reference;
        setSelectedNotification(newSelectedNotification);
        history.push({
            pathname: `${baseUrl}/notifications/detail/${ref.section}/${ref.type}/${ref.id}`,
        });
        if (!newSelectedNotification.read) {
            const markedNotifications = getMarkedNotificationsByReferenceId(newSelectedNotification.reference.id, groups);
            setGroups(markedNotifications);
        }
    };
    const isShowingDetails = match.params.section;
    if (isLoading) {
        return react_1.default.createElement(Loader_1.default, null);
    }
    return (react_1.default.createElement(NotificationsPage, null,
        groups && groups.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
            windowWidth >= 1000 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NotificationList_1.default, { notificationGroups: groups, checkDetails: checkDetails, selectedNotification: selectedNotification }),
                react_1.default.createElement(NotificationDetail_1.default, { selectedNotification: selectedNotification, fetchNotifications: fetchNotificationList, setSelectedNotification: setSelectedNotification }))),
            windowWidth < 1000 && (react_1.default.createElement(react_1.default.Fragment, null,
                isShowingDetails && (react_1.default.createElement(NotificationDetail_1.default, { selectedNotification: selectedNotification, fetchNotifications: fetchNotificationList, setSelectedNotification: setSelectedNotification })),
                !isShowingDetails && (react_1.default.createElement(NotificationList_1.default, { notificationGroups: groups, checkDetails: checkDetails, selectedNotification: selectedNotification })))))) : (react_1.default.createElement(NoNotificationsWrapper, null,
            react_1.default.createElement(Notifications_1.default, { className: "notifications-icon" }),
            react_1.default.createElement(material_1.Typography, null,
                " ",
                i18n_js_1.default.t("message_center_no_notifications_yet"),
                " "))),
        react_1.default.createElement(PermisisonWrapper, null,
            react_1.default.createElement(NotificationPermissions_1.default, null)),
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 3000, open: Boolean(toast), message: i18n_js_1.default.t("notification_center_marked_as_read_toast_text"), anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, className: "snackbar", action: react_1.default.createElement(CheckCircleOutline_1.default, { fontSize: "small" }) })));
};
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(Notifications));
